import React from 'react';
import PropTypes from 'prop-types';

import {
  Wrapper,
  CircleWrapper,
  Svg,
  Circle,
  Value,
  Label,
} from './Unit.styled';

const Unit = ({ value, max, label, shouldAnimate }) => (
  <Wrapper>
    <CircleWrapper>
      <Svg>
        <Circle />
        <Circle
          isValue
          shouldAnimate={shouldAnimate}
          style={{
            strokeDashoffset: max - value,
            strokeDasharray: max,
            transition: max - value === 1 ? 'none' : undefined,
          }}
          pathLength={max}
          suppressHydrationWarning
        />
      </Svg>
      <Value data-testid={label} suppressHydrationWarning>
        {value}
      </Value>
    </CircleWrapper>
    <Label>{label}</Label>
  </Wrapper>
);

Unit.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  shouldAnimate: PropTypes.bool.isRequired,
};

export default Unit;
